export default "__VITE_ASSET__a69c4093__"